<template>
<div class="chapter">
<div class="inner_page">
<p class="p7"><span class="t7">By</span> D.W. M<span class="t8">ARCHWELL</span></p>
<p class="p0"><span class="t7">All That Heaven Will Allow</span></p>
<p class="p0"><span class="t7">Comfort</span></p>
<p class="p0"><span class="t7">Even the Innocent</span></p>
<p class="p0"><span class="t7">Falling • When Memory Fails</span></p>
<p class="p0"><span class="t7">A Fine Mingling</span></p>
<p class="p0"><span class="t7">Mitchell’s Presence</span></p>
<p class="p0"><span class="t7">Pictures on Silence</span></p>
<p class="p0"><span class="t7">The Shared Harvest</span></p>
<p class="p0"><span class="t7">Sins of the Father</span></p>
<p class="p0"><span class="t7">A Still, Small Voice</span></p>
<p class="p0"><span class="t7">Until</span></p>
<p class="p8"><span class="t7">Wishing on a Blue Star (Dreamspinner Anthology)</span></p>
<p class="p0"><span class="t9">G</span><span class="t10">OOD</span> <span class="t10">TO</span> <span class="t9">K</span><span class="t10">NOW</span></p>
<p class="p0"><span class="t7">Good to Know</span></p>
<p class="p0"><span class="t7">An Earlier Heaven</span></p>
<p class="p0"><span class="t7">Roots and Wings</span></p>
<p class="p9"><span class="t7">Published by</span> D<span class="t8">REAMSPINNER</span> P<span class="t8">RESS</span></p>
<p class="p0"><span class="t7">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?5171aec8